import WithApplicationId from 'utils/WithApplicationId';
import BillingStepWithApplicationId from './components/BillingStepWithApplicationId/BillingStepWithApplicationId';

export default WithApplicationId({
	Component: BillingStepWithApplicationId,
	stepName: 'Billing',
});
